import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/components/Pages/Main/';
import Login from '@/components/Pages/Login';
import Trend from '@/components/Pages/Trend/';

Vue.use(Router);

export const constantRouterMap = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/trend',
    name: 'Trend',
    component: Trend,
  },
  {
    path: '',
    name: 'Main',
    component: Main,
    redirect: '',
  },
];

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});
